import { commissionStepfromJSON, CommissionStepRecord, ICommissionStepData } from "common/records/CommissionStep";
import { List, Record } from "immutable";
import { v4 as uuidV4 } from "uuid";

export const commissionCustomConfigfromJSON = (
  json: Partial<ICommissionCustomConfigData>,
): CommissionCustomConfigRecord => {
  const record: ICommissionCustomConfigRecord = { ...(json as any) };

  if (json.steps) {
    record.steps = List(json.steps.map((s: any, i: number) => commissionStepfromJSON(s).set("id", uuidV4())));
  }

  record.required = List(json.required || []);

  return new CommissionCustomConfigRecord(record);
};

export interface ICommissionCustomConfigData {
  name: string;
  required: string[];
  steps: ICommissionStepData[];
}

export interface ICommissionCustomConfigRecord {
  name: string;
  required: List<string>;
  steps: List<CommissionStepRecord>;
}

export const defaultCommissionCustomConfigProps = {
  name: "",
  required: List<string>(),
  steps: List<CommissionStepRecord>(),
};

export class CommissionCustomConfigRecord
  extends Record<ICommissionCustomConfigRecord>(defaultCommissionCustomConfigProps)
  implements ICommissionCustomConfigRecord {}
